import React, { useState } from 'react';
import { BasicLayout } from '../../shared/layout';
import { useAuth } from '../../context/AuthProvider';
import { useNotificationCenter } from '../../shared/components/toast';
import {
  OnboardingTemplate,
  MarketingTemplate,
} from '../../modules/users/components';
import { LoginRequest } from '../../modules/users/infra/types/LoginRequest.type';

function LoginPage() {
  const { handleLogin, loginStatus } = useAuth();
  const { addNotification } = useNotificationCenter();

  const initialState: LoginRequest = { credential: '', password: '' };
  const [loginRequest, setLoginRequest] = useState<LoginRequest>(initialState);

  const onSubmitLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { credential, password } = loginRequest;
    if (validateInputs(credential, password)) {
      handleLogin(credential, password);
    }
  };

  const validateInputs = (credentials: string, password: string): boolean => {
    if (!!credentials === false) {
      addNotification(
        {
          title: 'Error',
          description: 'Username is a required field. Please try again!',
        },
        {
          variant: 'ERROR',
        },
      );
      return false;
    }

    if (!!password === false) {
      addNotification(
        {
          title: 'Error',
          description: 'Password is a required field. Please try again!',
        },
        {
          variant: 'ERROR',
        },
      );
      return false;
    }

    return true;
  };

  const handleOnUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginRequest((currentState) => ({
      ...currentState,
      [name]: value,
    }));
  };

  return (
    <BasicLayout>
      <div className='mx-auto flex w-10/12 flex-1 flex-col items-center justify-between xl:mt-20 xl:flex-row'>
        <div className='xl:flex-1'>
          <MarketingTemplate />
        </div>
        <div className='w-full xl:w-auto xl:flex-1'>
          <OnboardingTemplate
            isLoading={loginStatus}
            onSubmit={onSubmitLogin}
            onChange={handleOnUpdate}
          />
        </div>
      </div>
    </BasicLayout>
  );
}

export default LoginPage;
